<script setup lang="ts">
import TransactionsPageCharater from '~/components/@pages/transactions/[txnHash]/TransactionsPageCharater.vue'
import TransactionAiLikeSummary from '~/components/@pages/transactions/[txnHash]/TransactionAiLikeSummary.vue'
import TransactionsPageSummary from '~/components/@pages/transactions/[txnHash]/TransactionsPageSummary.vue'
import TransactionsPageTabs from '~/components/@pages/transactions/[txnHash]/TransactionsPageTabs.vue'
import BackButton from '~/components/button/BackButton.vue'

const txnHash = useRoute().params.txnHash as string

const ellipsisTxnHash = computed(() => {
  return `${txnHash.slice(0, 8)}...${txnHash.slice(-6)}`
})
useSeoMeta(getMeta(`Transaction ${ellipsisTxnHash.value}`, `Explore details of Transaction ${ellipsisTxnHash.value}`))

</script>

<template>
  <div class="relative">
    <BackButton
      :url="routes.getTransactionsPage()"
      route-back-possible
    />
    <TransactionsPageSummary />
    <div class="my-4 border-t border-t-primary/10" />
    <TransactionAiLikeSummary />
    <div class="my-4 border-t border-t-primary/10" />
    <TransactionsPageTabs class="relative z-10" />
    <div class="relative">
      <TransactionsPageCharater class="transaction-character" />
      <NuxtPage />
    </div>
  </div>
</template>

<style scoped lang="scss">
.transaction-character {
  @apply -top-36 right-8;

  @include md {
    @apply -top-16 right-4;
  }

  @include sm {
    @apply -top-[150px] -right-4;
  }
}
</style>